import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class AppTitleService {
  private readonly appName = 'e-Likita';

  constructor(private titleService: Title) {}

  setTitle(pageTitle: string) {
    // Strip app name if it was accidentally included
    const clean = pageTitle
      .replace(/[-|]\s*e-?likita\d*/gi, '')
      .trim()
      .replace(/[-|]\s*$/, '')
      .trim();

    this.titleService.setTitle(`${clean} | ${this.appName}`);
  }

  setDynamicTitle(pageTitle: string, entityName: string) {
    const clean = pageTitle
      .replace(/[-|]\s*e-?likita/gi, '')
      .trim()
      .replace(/[-|]\s*$/, '')
      .trim();

    this.titleService.setTitle(`${entityName} - ${clean} | ${this.appName}`);
  }
}
